import { BaseStore, StoreFlags } from './_base';

import { Account, accountService } from '../services/accounts';


class AccountStore extends BaseStore<Account> {
  async getAccount(): Promise<Account> {
    return (await this.retrieveAllLocalOrRemote())[0].entry;
  }
}

export const accountStore = new AccountStore("accounts", accountService, 60 * 60 * 24 * 2, new Set([StoreFlags.RETRIEVE_ALL]));
